import * as React from "react"
import { Box, Stack } from "@chakra-ui/react"
import Head from "next/head"

import { Hero } from "components/Hero"
import { Intro } from "components/Intro"
import { JoinTheKlub } from "components/JoinTheKlub"
import { Klasses } from "components/Klasses"
import { Kollaborate } from "components/Kollaborate"
import { Kompetitions } from "components/Kompetitions"
import { Partners } from "components/Partners"

import { Benefits } from "./Benefits"

export default function Home() {

  return (
    <>
      <Head>
        <title>Kunstbende</title>
      </Head>

      <Box mb={28} aria-label="Hero sectie">
        <Hero />
      </Box>

      <Box 
        px={{ base: 6, md: 20, lg: 28 }} 
        mb={{ base: 28, lg: 24 }}
        role="region"
        aria-label="Introductie sectie"
      >
        <Intro />
      </Box>

      <Box 
        px={{ base: 6, md: 20, lg: 28 }} 
        mb={{ base: 28, lg: 24 }}
        role="region"
        aria-label="Voordelen sectie"
      >
        <Benefits />
      </Box>

      <Stack 
        w="100%" 
        pl={{ base: 0, md: 20, lg: 28 }} 
        pr={0} 
        mb={{ base: 20, lg: 20 }}
        role="region"
        aria-label="Kollaborate sectie"
      >
        <Kollaborate />
      </Stack>

      <Stack 
        w="100%" 
        mb={{ base: 28, lg: 28 }} 
        spacing={{ base: 4, md: 4 }}
        role="region"
        aria-label="Klassen sectie"
      >
        <Klasses />
      </Stack>

      <Stack 
        w="100%" 
        px={{ base: 6, md: 20, lg: 28 }} 
        mb={{ base: 40, lg: 24 }}
        role="region"
        aria-label="Wedstrijden sectie"
      >
        <Kompetitions />
      </Stack>

      <Stack 
        w="100%" 
        px={{ base: 6, md: 20, lg: 28 }} 
        mb={{ base: 40, lg: 40 }}
        role="region"
        aria-label="Word lid sectie"
      >
        <JoinTheKlub />
      </Stack>

      <Stack 
        w="100%" 
        px={{ base: 6, md: 20, lg: 28 }} 
        mb={{ base: 20, lg: 32 }}
        role="region"
        aria-label="Partners sectie"
      >
        <Partners />
      </Stack>
    </>
  )
}
